import {MessageCardUserType, UserType} from './types';

export const formatName = (source: string, max = 15) => (source.length > max ? source.substring(0, max) + '…' : source);
export const getFullName = (user?: UserType | MessageCardUserType, max?: number) =>
  formatName(`${user?.firstName} ${user?.lastName}`, max);
